import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, take, takeUntil } from 'rxjs';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { EmbedData } from '../../data/embed';
import { SelectedProjectListControllerComponent } from '../selected-project-list-controller/selected-project-list-controller.component';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/user/user.service';
import { ThreedProject } from '../../../../workspace-layout/commons/services/project-controller/project-controller';

@Component({
  selector: 'preset-setting-tool',
  imports: [SelectedProjectListControllerComponent],
  templateUrl: './preset-setting-tool.component.html',
  styleUrl: './preset-setting-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresetSettingToolComponent implements OnInit, OnDestroy {
  public embedData: EmbedData | undefined;

  public selectedProjectIndex: number = 0;
  public presetList: Array<any> = [];

  private unsubscribeAll: Subject<any> = new Subject();
  constructor(
    private threeGraphqlService: ThreeGraphqlService,
    private userService: UserService,
    private embedService: EmbedService,
    private router: Router,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.getEmbedData();
    this.getSelectedProjectIndex();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  public isMainPreset(preset: any): boolean {
    if (!this.embedData) return false;
    if (!this.embedData.projects) return false;
    if (this.embedData.projects.length === 0) return false;
    if (!this.embedData.projects[this.selectedProjectIndex]) return false;
    if (!this.embedData.projects[this.selectedProjectIndex].mainPreset) return false;
    return this.embedData.projects[this.selectedProjectIndex].mainPreset.uuid === preset.uuid;
  }

  public onClickGoCreatePresetBtn(): void {
    if (!this.embedData) return;
    console.log(this.userService.name ? this.userService.name : 'default');
    console.log(this.embedData.projects[this.selectedProjectIndex].template);
    this.router.navigate([
      '/',
      'workspace',
      this.userService.name ? this.userService.name : 'default',
      this.embedData.projects[this.selectedProjectIndex].template.slug,
    ]);
  }

  public clickPreset(preset: any): void {
    if (!this.embedData) return;
    if (!this.embedData.projects) return;
    if (this.embedData.projects.length === 0) return;
    if (!this.embedData.projects[this.selectedProjectIndex]) return;

    this.threeGraphqlService
      .addEmebedProjectPreset(this.embedData.projects[this.selectedProjectIndex].uuid, preset.uuid)
      .pipe(take(1))
      .subscribe((embedData: any) => {
        if (!this.embedData) return;
        if (!this.embedData.projects) return;
        if (this.embedData.projects.length === 0) return;
        if (!this.embedData.projects[this.selectedProjectIndex]) return;
        this.embedData.projects[this.selectedProjectIndex].presets = embedData.presets;
        console.log('clickPreset');
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
    // this.embedData.projects[this.selectedProjectIndex].presets.push(preset);
  }

  public clickAddMainPreset(preset: any): void {
    if (!this.embedData) return;
    if (!this.embedData.projects) return;
    if (this.embedData.projects.length === 0) return;
    if (!this.embedData.projects[this.selectedProjectIndex]) return;
    this.threeGraphqlService
      .updateEmbedProjectMainPreset(
        this.embedData.projects[this.selectedProjectIndex].uuid,
        preset.uuid,
      )
      .pipe(take(1))
      .subscribe((embedData: any) => {
        if (!this.embedData) return;
        if (!this.embedData.projects) return;
        if (this.embedData.projects.length === 0) return;
        if (!this.embedData.projects[this.selectedProjectIndex]) return;
        this.embedData.projects[this.selectedProjectIndex].mainPreset = embedData.mainPreset;
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
  }

  public clickSelectedPreset(preset: any): void {
    this.threeGraphqlService
      .deleteEmebedProjectPreset(preset.uuid)
      .pipe(take(1))
      .subscribe((embedData: any) => {
        if (!this.embedData) return;
        if (!this.embedData.projects) return;
        if (this.embedData.projects.length === 0) return;
        if (!this.embedData.projects[this.selectedProjectIndex]) return;
        this.embedData.projects[this.selectedProjectIndex].presets = this.embedData.projects[
          this.selectedProjectIndex
        ].presets.filter((p: any) => p.uuid !== preset.uuid);
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
  }

  private getEmbedData(): void {
    this.embedService.embedData$.pipe(takeUntil(this.unsubscribeAll)).subscribe((embedData) => {
      if (!embedData) return;
      this.embedData = embedData;

      if (!this.embedData) return;
      if (!this.embedData.projects) return;
      if (this.embedData.projects.length === 0) return;
      if (!this.embedData.projects[this.selectedProjectIndex]) return;

      this.getPersnalProject();
      this.cd.markForCheck();
    });
  }

  private getSelectedProjectIndex(): void {
    this.embedService.selectedProjectIndex$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((index) => {
        this.selectedProjectIndex = index;

        if (!this.embedData) return;
        if (!this.embedData.projects) return;
        if (this.embedData.projects.length === 0) return;
        if (!this.embedData.projects[this.selectedProjectIndex]) return;

        this.getPersnalProject();
        this.cd.markForCheck();
      });
  }

  private getPersnalProject(): void {
    this.threeGraphqlService
      .searchUserProejectByTempleteSlug(
        this.embedData?.projects[this.selectedProjectIndex].template.slug || '',
      )
      .pipe(take(1))
      .subscribe((project: ThreedProject) => {
        if (!project) {
          this.presetList = [];
          this.cd.markForCheck();
          return;
        }
        this.threeGraphqlService
          .getProjectPresets(project.uuid)
          .pipe(take(1))
          .subscribe((presets) => {
            this.presetList = presets;
            this.cd.markForCheck();
          });
      });
  }
}
